var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_886_15766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3211 9.50176L4.56342 8.13306V18.2464C4.56342 18.7083 4.93791 19.0827 5.39987 19.0827H18.7859C19.2479 19.0827 19.6224 18.7083 19.6224 18.2464V14.5203L12.3211 9.50176Z",
    fill: "#185C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3211 0.833252H5.39987C4.93791 0.833252 4.56342 1.20766 4.56342 1.66953V5.3956L12.3211 9.95794L16.428 11.3266L19.6224 9.95794V5.3956L12.3211 0.833252Z",
    fill: "#21A366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.56342 5.39551H12.3211V9.95785H4.56342V5.39551Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M10.1156 4.48315H4.56342V15.889H10.1156C10.5769 15.8875 10.9506 15.514 10.9521 15.0527V5.31943C10.9506 4.85819 10.5769 4.48465 10.1156 4.48315Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.65928 4.93945H4.56342V16.3453H9.65928C10.1206 16.3438 10.4942 15.9703 10.4957 15.509V5.77573C10.4942 5.31449 10.1206 4.94095 9.65928 4.93945Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.65928 4.93945H4.56342V15.4328H9.65928C10.1206 15.4313 10.4942 15.0578 10.4957 14.5966V5.77573C10.4942 5.31449 10.1206 4.94095 9.65928 4.93945Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.20294 4.93945H4.56342V15.4328H9.20294C9.66428 15.4313 10.0379 15.0578 10.0394 14.5966V5.77573C10.0379 5.31449 9.66428 4.94095 9.20294 4.93945Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.836454 4.93945H9.20284C9.6648 4.93945 10.0393 5.31387 10.0393 5.77573V14.1403C10.0393 14.6022 9.6648 14.9766 9.20284 14.9766H0.836454C0.374492 14.9766 0 14.6022 0 14.1403V5.77573C0 5.31387 0.374492 4.93945 0.836454 4.93945Z",
    fill: "url(#paint0_linear_886_15766)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.59052 12.6762L4.35013 9.95021L2.73791 7.23926H4.0348L4.91461 8.97295C4.99584 9.13765 5.05151 9.25992 5.08163 9.34067H5.09304C5.15084 9.20927 5.21169 9.08168 5.27557 8.95789L6.21607 7.24017H7.40664L5.75335 9.93515L7.44863 12.6762H6.18185L5.1656 10.7733C5.11773 10.6923 5.07711 10.6072 5.04422 10.5191H5.02916C4.99939 10.6055 4.95989 10.6881 4.91142 10.7655L3.86506 12.6762H2.59052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7858 0.833252H12.3209V5.3956H19.6222V1.66953C19.6222 1.20766 19.2477 0.833252 18.7858 0.833252Z",
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3209 9.95801H19.6222V14.5204H12.3209V9.95801Z",
    fill: "#107C41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_886_15766",
    x1: 1.74403,
    y1: 4.286,
    x2: 8.29317,
    y2: 15.6313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_886_15766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.39793a8382092ac0fbb7e53bf579d825.svg";
export { ForwardRef as ReactComponent };